import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { SignInPageContent } from 'client/contents/SignInContent/SignInContent'

type TProps = {}

const SignInPage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <SignInPageContent />
    </article>
  )
}

export default SignInPage
